"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagsGroupPropTypes = exports.TagsCatalogPropTypes = exports.SankeyNodePropTypes = exports.SankeyLinkPropTypes = exports.SankeyDataPropTypes = exports.DimensionPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var DimensionPropTypes = _propTypes.default.arrayOf(_propTypes.default.shape({
  group_name: _propTypes.default.string.isRequired,
  tags: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
  selected_tags: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired
}).isRequired).isRequired;

exports.DimensionPropTypes = DimensionPropTypes;
var SankeyNodePropTypes = {
  // identification
  idNode: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  //- level attributes
  dimensions: _propTypes.default.objectOf(_propTypes.default.shape({
    parent_name: _propTypes.default.string,
    level: _propTypes.default.number
  }).isRequired).isRequired,
  // DISPLAY ATTRIBUTES
  // display controls the agregation desagregation process. 
  display: _propTypes.default.bool.isRequired,
  // node_visible controls the other process in particular tags manipulations
  node_visible: _propTypes.default.bool.isRequired,
  // shape_visible and label_visible control the visibility of the element of the node
  shape_visible: _propTypes.default.bool.isRequired,
  label_visible: _propTypes.default.bool.isRequired,
  color: _propTypes.default.string.isRequired,
  colorFavoriteTags: _propTypes.default.objectOf(_propTypes.default.shape({
    tag_associated: _propTypes.default.string.isRequired,
    color: _propTypes.default.string
  }).isRequired).isRequired,
  tag_favorite: _propTypes.default.objectOf(_propTypes.default.shape({
    tagGroup: _propTypes.default.string.isRequired,
    tagElement: _propTypes.default.string.isRequired
  }).isRequired).isRequired,
  node_parameter: _propTypes.default.string.isRequired,
  // geometry
  x: _propTypes.default.number.isRequired,
  y: _propTypes.default.number.isRequired,
  x_label: _propTypes.default.number,
  y_label: _propTypes.default.number,
  show_value: _propTypes.default.bool.isRequired,
  tooltip_text: _propTypes.default.string,
  // topology
  inputLinksId: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
  outputLinksId: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
  // semantic
  type: _propTypes.default.oneOf(['product', 'sector']),
  tags: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired).isRequired
};
exports.SankeyNodePropTypes = SankeyNodePropTypes;
var SankeyLinkPropTypes = {
  // identification
  idLink: _propTypes.default.string.isRequired,
  idSource: _propTypes.default.string.isRequired,
  idTarget: _propTypes.default.string.isRequired,
  // type of link
  recycling: _propTypes.default.bool,
  orientation: _propTypes.default.string.isRequired,
  arrow: _propTypes.default.bool.isRequired,
  // display_attribute
  label_position: _propTypes.default.string.isRequired,
  orthogonal_label_position: _propTypes.default.string.isRequired,
  label_on_path: _propTypes.default.bool.isRequired,
  label_visible: _propTypes.default.bool.isRequired,
  text_color: _propTypes.default.string.isRequired,
  color: _propTypes.default.string.isRequired,
  // value
  value: _propTypes.default.arrayOf(_propTypes.default.number.isRequired).isRequired,
  display_value: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
  tooltip_text: _propTypes.default.string,
  // geometry
  x_label: _propTypes.default.number,
  y_label: _propTypes.default.number,
  left_horiz_shift: _propTypes.default.number.isRequired,
  right_horiz_shift: _propTypes.default.number.isRequired,
  vert_shift: _propTypes.default.number.isRequired,
  shift_gap: _propTypes.default.number.isRequired,
  curvature: _propTypes.default.number.isRequired,
  curved: _propTypes.default.bool.isRequired,
  tags: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired).isRequired
};
exports.SankeyLinkPropTypes = SankeyLinkPropTypes;
var TagsGroupPropTypes = {
  group_name: _propTypes.default.string.isRequired,
  show_legend: _propTypes.default.bool.isRequired,
  tags: _propTypes.default.objectOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    shape: _propTypes.default.string,
    color: _propTypes.default.string,
    selected: _propTypes.default.bool.isRequired
  }).isRequired).isRequired,
  banner: _propTypes.default.string.isRequired
};
exports.TagsGroupPropTypes = TagsGroupPropTypes;

var TagsCatalogPropTypes = _propTypes.default.objectOf(_propTypes.default.shape(TagsGroupPropTypes).isRequired).isRequired;

exports.TagsCatalogPropTypes = TagsCatalogPropTypes;
//-------------------------
var SankeyDataPropTypes = {
  version: _propTypes.default.string.isRequired,
  node_width: _propTypes.default.number.isRequired,
  user_scale: _propTypes.default.number.isRequired,
  //height: PropTypes.number.isRequired,
  width: _propTypes.default.number.isRequired,
  h_space: _propTypes.default.number.isRequired,
  v_space: _propTypes.default.number.isRequired,
  left_shift: _propTypes.default.number.isRequired,
  right_shift: _propTypes.default.number.isRequired,
  max_shift: _propTypes.default.number.isRequired,
  legend_position: _propTypes.default.arrayOf(_propTypes.default.number.isRequired).isRequired,
  nodes: _propTypes.default.objectOf(_propTypes.default.shape(SankeyNodePropTypes).isRequired).isRequired,
  links: _propTypes.default.objectOf(_propTypes.default.shape(SankeyLinkPropTypes).isRequired).isRequired,
  display_style: _propTypes.default.shape({
    font_size: _propTypes.default.number.isRequired,
    sector_uppercase: _propTypes.default.bool.isRequired,
    sector_bold: _propTypes.default.bool.isRequired,
    sector_italic: _propTypes.default.bool.isRequired,
    product_uppercase: _propTypes.default.bool.isRequired,
    product_bold: _propTypes.default.bool.isRequired,
    product_italic: _propTypes.default.bool.isRequired,
    unit: _propTypes.default.bool.isRequired,
    filter: _propTypes.default.number.isRequired,
    filter_label: _propTypes.default.number.isRequired,
    global_curvature: _propTypes.default.number.isRequired,
    null_flux: _propTypes.default.bool.isRequired
  }).isRequired,
  tags_catalog: TagsCatalogPropTypes,
  // last indices used to increment in the id's :idNode idLink idTag idTagGroup
  tags_group_idx: _propTypes.default.number.isRequired,
  tag_idx: _propTypes.default.number.isRequired,
  node_idx: _propTypes.default.number.isRequired,
  link_idx: _propTypes.default.number.isRequired
};
exports.SankeyDataPropTypes = SankeyDataPropTypes;